<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="main-div" fxLayout="row wrap">

        <div fxLayout="row">
            <div fxLayout="column wrap" class="description-div">
                <div class="desc-div">
                    <div class="clo">
                        <p class="event-heading" [innerHTML]="ticketInfo?.heading1">
                        <p style="width:100%" [innerHTML]="ticketInfo?.subHeading1"></p>
                    </div>
                    <div>
                        <p class="event-heading" [innerHTML]="ticketInfo?.heading2">
                        </p>
                        <p style="width: 100%;" [innerHTML]="ticketInfo?.subHeading2"></p>
                    </div>
                    <div>
                        <p class="event-heading1" [innerHTML]="ticketInfo?.heading3">
                        </p>
                        <p style="width: 100%;" [innerHTML]="ticketInfo?.subHeading3"></p>
                    </div>
                </div>
            </div>

            <div fxLayout="column wrap" class="image-div">
                <img class="image" src="{{ticketInfo?.mainImage}}" alt="How-to-ticket-main-image">
            </div>

        </div>

        <div fxLayout="row wrap" class="button-main-div" fxLayoutGap="30px">

            <button class="btn" id="buy-spotlights-button" (click)="navigateToAllAccessPass()" type="button">ALL ACCESS
                PASS</button>

            <button *ngIf="isSpotlightSubscriptionActive&& !isAllSubscribed" class="btn" id="buy-spotlights-button"
                ng-click="initiatePurchase('SUBSCRIPTION_SPOTLIGHT')"
                (click)="initiatePurchase('SUBSCRIPTION_SPOTLIGHT')" type="button">SPOTLIGHT ACCESS PASS</button>

            <button *ngIf="isShowcaseSubscriptionActive &&  !isAllSubscribed" class="btn " id="buy-spotlights-button"
                ng-click="initiatePurchase('SUBSCRIPTION_SHOWCASE')" (click)="initiatePurchase('SUBSCRIPTION_SHOWCASE')"
                type="button">SHOWCASE ACCESS PASS</button>


            <div fxLayout="row wrap" class="button-div" fxLayoutAlign="right center"
                *ngFor="let btn of ticketInfo?.buttons">
                <a href="{{btn.url}}"><button class="btn"><span class="btn_effect">
                            {{btn.name}}</span></button></a>

            </div>
        </div>

    </div>

    <div class="spot-show-div" fxLayout="row wrap">

        <div fxLayout="row">
            <div class="title-div" fxLayout="row wrap" fxLayoutAlign="start center">
                <span class="event-heading">
                    {{ticketInfo.showcaseMovies.heading}} vs.
                    <span style="color: #de1b36;"> {{ticketInfo.spotlightEvents.heading}} </span>
                </span>
                <p class="event-details" [innerHTML]="ticketInfo.description"></p>
            </div>
        </div>

        <div class="movie-div" fxLayout="row wrap">

            <div class="flex-container">
                <div class="showcase-div">

                    <div class="show-head-div" [innerHTML]="ticketInfo.showcaseMovies.heading">
                    </div>

                    <div class="show-details-div">

                        <p class="access-info">
                            <span>ACCESS:</span>
                            <img src="/assets/images/showcase/Showcase_24-7.png" width="60px">
                            <span style="color: #de1b36;">
                                {{ this.ticketInfo.showcaseMovies.startDate | date : 'MMMM d': '-0800'
                                }}-{{this.ticketInfo.showcaseMovies.endDate | date : 'd, YYYY' : '-0800'}}</span>
                        </p>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description1"></p>
                        </div>

                        <div class="desc">
                            <img alt height="auto" src="/assets/images/showcase/Showcase_Watch_48h.png" width="100%">
                        </div>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description2"></p>
                        </div>

                        <div class="event-date-div" fxLayout="row wrap">

                            <div fxLayout="row" fxLayoutGap="100px">

                                <div fxLayout="row wrap" class="content-header">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Start.png"
                                        width="60px">
                                    <div class="content-sub-header">
                                        <div class="">Begin during</div>
                                        <div class="" style="color: #7cc922">{{ this.ticketInfo.showcaseMovies.startDate
                                            | date : 'MMMM d': '-0800' }}-{{this.ticketInfo.showcaseMovies.endDate |
                                            date : 'd' : '-0800'}}
                                        </div>
                                    </div>
                                </div>

                                <div fxLayout="row wrap" class="content-header">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Stop.png"
                                        width="60px">
                                    <div class="content-sub-header">
                                        <div class="">Complete by</div>
                                        <div class="" style="color: #de1b36">
                                            {{this.endDateRange | date : 'd' : '-0800'}} Midnight
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description3"></p>
                        </div>

                        <div fxLayout="row wrap">
                            <div fxLayout="row">
                                <div class="content-header" fxLayout="row wrap">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Deadline.png"
                                        width="140px">
                                </div>
                                <div class="content-header" fxLayout="row wrap">
                                    <p [innerHTML]="ticketInfo.showcaseMovies.description4"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="spotlight-div">

                    <div class="spot-head-div" [innerHTML]="ticketInfo.spotlightEvents.heading">
                    </div>

                    <div class="spot-details-div">

                        <div fxLayout="row wrap" class="access-div">
                            <div fxLayout="row">
                                <div class="spot-access-info">
                                    <span style="font-weight: 600;">ACCESS:</span>
                                    <br><br>
                                    <span class="date-time">Date & Time Specific</span>
                                    <div class="desc desc-alt">
                                        <p [innerHTML]="ticketInfo.spotlightEvents.description1"></p>
                                    </div>
                                </div>
                                <div class="content-header" fxLayout="row wrap">
                                    <img alt="" height="auto" src="/assets/images/showcase/Spotlight_Calendar_March.png"
                                        width="140px">
                                </div>
                            </div>
                        </div>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description2"></p>
                        </div>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description3"></p>
                        </div>

                        <div class="desc">
                            <img alt="" height="auto" src="/assets/images/showcase/Spotlight_Sequence.png" width="100%">
                        </div>

                        <div class="desc">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description4"></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-div" fxLayout="row wrap">
        <div fxLayout="row">
            <div fxLayout="column wrap" class="browser-div">
                <div class="desc-div">
                    <div>
                        <span class="event-heading" [innerHTML]="ticketInfo.accessInfo.title">
                        </span>
                        <p style="width:100%" [innerHTML]="ticketInfo.accessInfo.description"></p>
                    </div>
                    <div>
                        <span class="event-heading" [innerHTML]="ticketInfo.browserInfo.title">
                        </span>
                        <p style="width:100%" [innerHTML]="ticketInfo.browserInfo.description"></p>
                    </div>
                </div>
            </div>

            <div class="column-wrap" class="access-browser-info">
                <div class="join-button" style="align-items: center; justify-content: center;">
                    <a href="{{ticketInfo.joinButtonUrl}}">
                        <span class="header" style="color: #ffffff">
                            creatics.org/<b>signup</b>
                        </span>
                    </a>
                </div>
                <div>
                    <button class="btn1"><a href="{{ticketInfo.joinButtonUrl}}">
                            <span class="btn_effect1">
                                {{ticketInfo.joinButton}}</span>
                        </a></button>
                </div>
            </div>

        </div>
    </div>

    <div class="streaming-main-div" fxLayout="row wrap">

        <div fxLayout="row">

            <div class="streaming-sub-div" fxLayout="row wrap" fxLayoutAlign="start center">
                <span class="streaming-heading">
                    {{ticketInfo.streamingHeading}}</span>
                <div class="streaming-sub-heading">{{ticketInfo.streamingSubHeading}}</div>
            </div>

        </div>

        <div fxLayout="row">

            <div fxLayout="column wrap" class="streaming-div">
                <div class="sub-div" fxLayout="column" fxLayoutGap="20px">
                    <div *ngFor="let dev of ticketInfo.streamingDevices" fxLayoutGap="20px">
                        <span class="streaming-heading1" [innerHTML]="dev.name">
                        </span>
                        <div class="streaming-sub-heading1" [innerHTML]="dev.description"></div>
                    </div>
                </div>
            </div>

            <div fxLayout="column wrap" class="streaming-image-div">
                <img class="image1" height="auto" src="{{ticketInfo.streamingImage}}" width="90%"
                    alt="streaming-main-image">
            </div>

        </div>
    </div>

    <hr>

    <div class="footer-div">
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>

</div>

<!-- wev view ended -->

<!-- mobile view started -->

<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>

    <div class="mobile-navbar">
        <app-sidebar></app-sidebar>
    </div>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="main-div-mob" fxLayout="column wrap">

        <div fxLayout="column">

            <div fxLayout="column" class="description-div-mob">

                <div>
                    <p class="event-heading-mob event-mob" [innerHTML]="ticketInfo.heading1">
                    </p>

                    <p class="description" [innerHTML]="ticketInfo.subHeading1"></p>
                </div>
                <div>
                    <p class="event-heading-mob" [innerHTML]="ticketInfo.heading2">
                    </p>
                    <p class="description" [innerHTML]="ticketInfo.subHeading2"></p>
                </div>
                <div>
                    <p class="event-heading-mob" [innerHTML]="ticketInfo.heading3">
                    </p>
                    <p class="description" [innerHTML]="ticketInfo.subHeading3"></p>
                </div>
            </div>

            <div class="image-div-mob" fxLayout="column" fxLayoutAlign="start center">

                <img class="image-mob" src="{{ticketInfo.mainImage}}" alt="How-to-ticket-main-image">

            </div>

            <div fxLayout="column wrap" class="button-div-mob" fxLayoutGap="10px">

                <button class="mobileBtn " id="buy-spotlights-button" (click)="navigateToAllAccessPass()"
                    type="button">ALL ACCESS PASSES</button>

                <button *ngIf="isSpotlightSubscriptionActive&& !isAllSubscribed" class="mobileBtn"
                    id="buy-spotlights-button" (click)="initiatePurchase('SUBSCRIPTION_SPOTLIGHT')"
                    type="button">SPOTLIGHT ACCESS PASS</button>

                <button *ngIf="isShowcaseSubscriptionActive  && !isAllSubscribed " class="mobileBtn"
                    id="buy-spotlights-button" (click)="initiatePurchase('SUBSCRIPTION_SHOWCASE')"
                    type="button">SHOWCASE ACCESS PASSES</button>

                <div fxLayout="column wrap" *ngFor="let btn of ticketInfo.buttons">

                    <a href="{{btn.url}}"><button class="mobileBtn">{{btn.name}}</button></a>

                </div>
            </div>

        </div>
    </div>

    <div class="spot-show-div-mob" fxLayout="column wrap">

        <div class="title-div-mob" fxLayout="column">
            <span class="event-div-mob">
                {{ticketInfo.showcaseMovies.heading}} vs.
                <span style="color: #de1b36;"> {{ticketInfo.spotlightEvents.heading}} </span>
            </span>
            <p class="event-details-mob" [innerHTML]="ticketInfo.description"></p>
        </div>

        <div class="movie-div-mob" fxLayout="column wrap">

            <div fxLayout="column">

                <div fxLayout="column" class="showcase-div-mob">

                    <div class="show-head-div-mob" [innerHTML]="ticketInfo.showcaseMovies.heading">
                    </div>

                    <div class="show-details-div-mob">

                        <p class="access-info">
                            <span class="access-info-mob">ACCESS:</span>
                            <img src="/assets/images/showcase/Showcase_24-7.png" width="60px">
                            <br>
                            <span class="access-info-mob" style="color: #de1b36;">
                                {{ this.ticketInfo.showcaseMovies.startDate | date : 'MMMM d': '-0800'
                                }}-{{this.ticketInfo.showcaseMovies.endDate | date : 'd, YYYY' : '-0800'}}</span>

                        </p>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description1"></p>
                        </div>

                        <div class="desc-mob">
                            <img alt height="auto" src="/assets/images/showcase/Showcase_Watch_48h.png" width="100%">
                        </div>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description2"></p>
                        </div>

                        <div class="event-date-div" fxLayout="column wrap">

                            <div fxLayout="column">

                                <div fxLayout="row wrap" class="content-header">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Start.png"
                                        width="60px">
                                    <div class="content-sub-header">
                                        <div class="">Begin during</div>
                                        <div class="" style="color: #7cc922">
                                            {{ this.ticketInfo.showcaseMovies.startDate | date : 'MMMM d': '-0800'
                                            }}-{{this.ticketInfo.showcaseMovies.endDate | date : 'd' : '-0800'}}</div>
                                    </div>
                                </div>

                                <div fxLayout="row wrap" class="content-header">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Stop.png"
                                        width="60px">
                                    <div class="content-sub-header">
                                        <div class="">Complete by</div>
                                        <div class="" style="color: #de1b36">
                                            {{this.endDateRange | date : 'd' : '-0800'}} Midnight
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.showcaseMovies.description3"></p>
                        </div>

                        <div fxLayout="column wrap">
                            <div fxLayout="column">
                                <div class="content-header" fxLayout="row wrap">
                                    <img alt="" height="auto" src="/assets/images/showcase/Showcase_Deadline.png"
                                        width="140px">
                                </div>
                                <div class="content-header-mob" fxLayout="row wrap">
                                    <p [innerHTML]="ticketInfo.showcaseMovies.description4"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div fxLayout="column" class="spotlight-div-mob">

                    <div class="spot-head-div-mob" [innerHTML]="ticketInfo.spotlightEvents.heading">
                    </div>

                    <div class="spot-details-div-mob">

                        <div fxLayout="column wrap" class="access-div">
                            <div fxLayout="column">
                                <div class="spot-access-info">
                                    <span class="access-info-mob" style="font-weight: 600;">ACCESS:</span>
                                    <br>
                                    <span class="date-time access-info-mob">Date & Time Specific</span>
                                    <div class="desc desc-alt">
                                        <p [innerHTML]="ticketInfo.spotlightEvents.description1"></p>
                                    </div>
                                </div>
                                <div class="content-header" fxLayout="row wrap">
                                    <img alt="" height="auto" src="/assets/images/showcase/Spotlight_Calendar_March.png"
                                        width="140px">
                                </div>
                            </div>
                        </div>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description2"></p>
                        </div>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description3"></p>
                        </div>

                        <div class="desc-mob">
                            <img alt="" height="auto" src="/assets/images/showcase/Spotlight_Sequence.png" width="100%">
                        </div>

                        <div class="desc-mob">
                            <p [innerHTML]="ticketInfo.spotlightEvents.description4"></p>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="main-div-mob" fxLayout="column wrap">
        <div fxLayout="column">

            <div fxLayout="column wrap" class="browser-div-mob">

                <div>
                    <span class="event-heading-mob" [innerHTML]="ticketInfo.accessInfo.title">
                    </span>
                    <p class="description" [innerHTML]="ticketInfo.accessInfo.description"></p>
                </div>

                <div>
                    <span class="event-heading-mob" [innerHTML]="ticketInfo.browserInfo.title">
                    </span>
                    <p class="description" [innerHTML]="ticketInfo.browserInfo.description"></p>
                </div>
            </div>

            <div class="column-wrap" class="access-browser-info-mob">
                <div class="join-button">
                    <a href="{{ticketInfo.joinButtonUrl}}">
                        <span class="header" style="color: #ffffff">
                            creatics.org/<b>signup</b>
                        </span>
                    </a>
                </div>
                <div>
                    <button class="btn1"><a href="{{ticketInfo.joinButtonUrl}}">
                            <span class="btn_effect1">
                                {{ticketInfo.joinButton}}</span>
                        </a></button>
                </div>
            </div>

        </div>
    </div>

    <div class="streaming-main-div-mob" fxLayout="column wrap">

        <div class="streaming-sub-div-mob" fxLayout="column">
            <span class="streaming-heading-mob" [innerHTML]="ticketInfo.streamingHeading"></span>
            <p class="streaming-sub-heading-mob" [innerHTML]="ticketInfo.streamingSubHeading"></p>
        </div>

        <div class="" fxLayout="column wrap">

            <div fxLayout="column">

                <div fxLayout="column" class="streaming-div-mob">
                    <div class="sub-div-mob" fxLayout="column" fxLayoutGap="20px">
                        <div *ngFor="let dev of ticketInfo.streamingDevices" fxLayoutGap="20px">
                            <span class="streaming-heading1-mob" [innerHTML]="dev.name">
                            </span>
                            <p class="streaming-sub-heading1-mob" [innerHTML]="dev.description"></p>
                        </div>
                    </div>
                </div>

                <div fxLayout="column" class="streaming-image-div-mob">
                    <img class="image1" height="auto" src="{{ticketInfo.streamingImage}}" width="90%"
                        alt="streaming-main-image">
                </div>
            </div>

        </div>

    </div>

    <hr>

    <div class="footer-div">
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>

</div>